import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';
import { ListingPhoto } from './types/Listing';

interface UpdateListingPhotoOptions {
  format: string;
  rotate?: number;
  rotateIncrement?: number;
  set360?: boolean;
}

export default (makeCall: MakeCall) =>
  (
    listingId: number,
    photoId: number,
    { format, rotate, rotateIncrement, set360 }: UpdateListingPhotoOptions,
  ) =>
    makeCall<ListingPhoto[]>(
      'PUT',
      `${APIV2_URL}/listing/${listingId}/photo/${photoId}`,
      {
        query: { format },
        data: {
          rotate,
          rotateIncrement,
          set360,
        },
      },
    );
